import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'

import {
  StyledSuccessTag,
  StyledWarningTag,
  StyledDangerTag,
  StyledInfoTag,
  StyledFilledActiveTag,
  StyledFilledInactiveTag,
} from './styles/Tags.styles'

// Type definitions for tag component props
interface TagProps {
  label: string
  color?: string
  bg?: string
}

interface FilledTagProps {
  label: string
  color?: string
}

// Exported components with their respective props
export const TagSuccess: React.FC<TagProps> = ({ label, color, bg }) => (
  <StyledSuccessTag color={color} bg={bg}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledSuccessTag>
)

export const TagWarning: React.FC<TagProps> = ({ label, color, bg }) => (
  <StyledWarningTag color={color} bg={bg}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledWarningTag>
)

export const TagDanger: React.FC<TagProps> = ({ label, color, bg }) => (
  <StyledDangerTag color={color} bg={bg}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledDangerTag>
)

export const TagInfo: React.FC<TagProps> = ({ label, color, bg }) => (
  <StyledInfoTag color={color} bg={bg}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledInfoTag>
)

export const TagFilledActive: React.FC<FilledTagProps> = ({ label, color }) => (
  <StyledFilledActiveTag color={color}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledFilledActiveTag>
)

export const TagFilledInactive: React.FC<FilledTagProps> = ({
  label,
  color,
}) => (
  <StyledFilledInactiveTag color={color}>
    <FontAwesomeIcon icon={faCircle} size="xs" /> {label}
  </StyledFilledInactiveTag>
)
